import { DialogFooter } from '@indeed/ifl-components'

export default DialogFooter
